import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const AttachmentBody = ({ data, title }) => {

    return (
      <div>
        <h6>{title}</h6>
        <Link to={data}>nomeallegato.estensione</Link>
      </div>
    );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal,
  };
};

export default connect(mapStateToProps)(AttachmentBody);
